/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Ai_TakeoverInputs */

const en_learn_ai_takeover = /** @type {(inputs: Learn_Ai_TakeoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[Takeover](/ai-takeover). How AI could take over the world.`)
};

/**
* | output |
* | --- |
* | "[Takeover](/ai-takeover). How AI could take over the world." |
*
* @param {Learn_Ai_TakeoverInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const learn_ai_takeover = /** @type {((inputs?: Learn_Ai_TakeoverInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Ai_TakeoverInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_learn_ai_takeover(inputs)
});